// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__VlyzS","title":"style_title__vcUXg","text":"style_text__lrPde","navigate":"style_navigate__988VB"};